import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  applyWithdrawalRequest: ["withdrawal_id"],
  applyWithdrawalSuccess: ["dataWithdrawal"],
  applyWithdrawalFailure: ["status"],
});

export const ApplyWithdrawalTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  fetching: null,
  success: null,
  error: null,
  withdrawal_id: null,
  dataWithdrawal: null,
  status: null,
});

export const ApplyWithdrawalSelectors = {
  getData: (state: any) => state.applyWithdrawal.data,
  isFetching: (state: any) => state.applyWithdrawal.fetching,
  isSuccess: (state: any) => state.applyWithdrawal.success,
  hasError: (state: any) => state.applyWithdrawal.error,
};

export const request = (state: any, action: any) => {
  const { withdrawal_id } = action;
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    withdrawal_id,
    dataWithdrawal: null,
    status: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { dataWithdrawal } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    dataWithdrawal,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any, action: any) => {
  const { status } = action;
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    status,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.APPLY_WITHDRAWAL_REQUEST]: request,
  [Types.APPLY_WITHDRAWAL_SUCCESS]: success,
  [Types.APPLY_WITHDRAWAL_FAILURE]: failure,
});
